module.exports = __webpack_public_path__ + "static/img/img_form_1@2x_en.0426df26.png";